import React from "react";
import { connect } from "react-redux";
import { Store } from "redux";
import { createReduxStore } from "@/store/reduxHelpers";
import { TICKETING_VIEWS } from "./reducers/ticketing";
import { Provider } from "react-redux";
import { reducers } from "./reducers/reducers";
import WorkerInboxContainer from "./WorkerInboxContainer";
import InboxItem from "./InboxItem";
import TicketingNavigation from "./TicketingNavigation";
import TicketList from "./TicketList";
import * as Auth from "@/lib/auth";
import { USER_TAGS } from "@/lib/CommonTags.generated";
import type { ReduxState } from "./reducers/reducers";

import "./styles/index.scss";

type TicketingViewsProps = {
    selected_view?: keyof typeof TICKETING_VIEWS;
    is_kiosk: boolean;
};
type TicketingViewsState = {};

class TicketingViews extends React.Component<TicketingViewsProps, TicketingViewsState> {
    render() {
        const { selected_view } = this.props;
        switch (selected_view) {
            case TICKETING_VIEWS.tickets:
                return <TicketList />;
            case TICKETING_VIEWS.inbox:
                return <WorkerInboxContainer />;
            case TICKETING_VIEWS.inbox_item:
                return <InboxItem is_kiosk={this.props.is_kiosk} />;
            default:
                return null;
        }
    }
}

const mapState = (state: ReduxState) => ({ selected_view: state.ticketing.selected_view });

type ReduxProps = ReturnType<typeof mapState>;

const ConnectedTicketingViews = connect<ReduxProps, {}, {}, ReduxState>(mapState)(TicketingViews);

type TicketingAppProps = {};
type TicketingAppState = {};

export default class TicketingApp extends React.Component<TicketingAppProps, TicketingAppState> {
    store: Store<ReduxState>;
    is_kiosk: boolean = Auth.getUserTag(USER_TAGS.kiosk) === "true";

    constructor(props: TicketingAppProps) {
        super(props);
        this.store = createReduxStore(reducers);
    }

    render() {
        if (!this.store) {
            return null;
        }

        return (
            <Provider store={this.store}>
                <div className="ticketing">
                    <TicketingNavigation is_kiosk={this.is_kiosk} />
                    <ConnectedTicketingViews is_kiosk={this.is_kiosk} />
                </div>
            </Provider>
        );
    }
}
